// extracted by mini-css-extract-plugin
module.exports = {"container":"layout-module--container--1sCSw","content":"layout-module--content--3B0uJ","mainContent":"layout-module--mainContent--2EVN4"};